import React, { useContext } from "react";
import { Box, Checkbox, TextField, FormControlLabel } from "@material-ui/core";

import { Autocomplete } from "@material-ui/lab";

import ConfigurationListsContext from "../../context/configurationListsContext";

const RecruitersMultipleSelection = ({
  label,
  selectedRecruiters,
  onRecruiterChange,
}) => {
  const usersContext = useContext(ConfigurationListsContext);
  const userIdAndLabel = usersContext.users
    .sort((a, b) => (a.display_name > b.display_name ? 1 : -1))
    .map((user) => {
      return {
        id: user.id,
        display_name: user.display_name,
      };
    });

  return (
    <Box width={400}>
      <Autocomplete
        multiple
        id="checkboxes-tags-demo"
        options={userIdAndLabel}
        disableCloseOnSelect
        getOptionLabel={(user) => user.display_name}
        getOptionSelected={(option, value) => option.id === value.id}
        onChange={(event, value) =>
          onRecruiterChange(value.map((user) => (user.id ? user.id : user)))
        }
        limitTags={3}
        value={selectedRecruiters.map((ss) => {
          const index = userIdAndLabel.findIndex((usr) => usr.id === ss);
          return index > -1 ? userIdAndLabel[index] : [];
        })}
        renderOption={(props, user, state) => (
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"flex-start"}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={selectedRecruiters.includes(props.id)}
                  color="primary"
                />
              }
              label={props.display_name}
            />
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            variant="filled"
            {...params}
            label={"Filter by recruiters"}
            placeholder="Recruiter..."
          />
        )}
      />
    </Box>
  );
};

export default RecruitersMultipleSelection;
